import {
  easeInOutSine,
  smoothstep,
  clamp,
  w, h,
  frameN,
  setFrameN,
  getCanvasSize,
  setupCommon,
  drawCommon,
  make,
} from '../js/common.js';

let img;
const imgUrl = new URL('./bird.jpg', import.meta.url);
export function preload() {
	img = loadImage(imgUrl.href);
}

export function setup() {
	setupCommon();
	noSmooth();
	stroke(0, 0, 0, 0.25);
}

let xPrev = 0;
let yPrev = 0;
let cycles = -1;
export function draw() {

	/**
	 * Pixel Sorting
	 */
	const psort = (x, idxFn, t) => {
		// TODO: filter out segments < 5 long
		let segments = [];
		for (let y = 0; y < img.height; y++) {
			if (segments.length % 2 == 0 && img.pixels[idxFn(x, y)] < t + 10)
				segments.push(y);
			else if (segments.length % 2 == 1 && img.pixels[idxFn(x, y)] > t - 10)
				segments.push(y);
		}
		if (segments.length % 2 == 1) segments.push(img.height);

		for (let i = 0; i < segments.length / 2; i++) {
			const y1 = segments[i];
			const y2 = segments[i + 1];

			[...Array(y2 - y1).keys()]
				.map(y => img.pixels[idxFn(x, y + y1)])
				.sort((colorA, colorB) => {
					if (colorA < colorB) return -1;
					else if (colorA > colorB) return 1;
					else return 0;
				})
				.forEach((color, idx) => {
					const loc = idxFn(x, idx + y1);

					img.pixels[loc] = color + Math.floor(Math.sin(y1 * 0.01) * 5);
					img.pixels[loc + 1] = color + Math.floor(Math.sin(x * 0.01) * 5);
					img.pixels[loc + 2] = color + Math.floor(Math.sin(y2 * 0.5) * 5);
					img.pixels[loc + 3] = 255;
				});
		}
	}

	drawCommon();

	setFrameN(frameN * 6);
	setFrameN(frameN - Math.floor(frameN));

	if (frameN == 0)
		cycles++;

	if (frameN < 0.5) {
		yPrev = 0;

		const n = frameN * 2;
		const xNext = Math.floor(n * width);
		img.loadPixels();
		for (let x0 = xPrev; x0 < xNext; x0++) {
			psort(x0, (x, y) => (x + y * img.width) * 4, 150 + cycles * 5);
			line(x0, 0, x0, height);
		}
		img.updatePixels();
		xPrev = xNext;
	}

	else {
		xPrev = 0;

		const n = (frameN - 0.5) * 2;
		const yNext = Math.floor(n * height);
		img.loadPixels();
		for (let y0 = yPrev; y0 < yNext; y0++) {
			psort(y0, (y, x) => (x + y * img.width) * 4, 50 + cycles * 5);
		}
		img.updatePixels();
		yPrev = yNext;
	}

	image(img, 0, 0, width, height, 0, 0, img.width, img.height, COVER);
	line(xPrev * (width / img.width), 0, xPrev * (width / img.width), height);
	line(0, yPrev * (height / img.height), width, yPrev * (height / img.height));
}
